<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Delete User</div>
    <div>
      <p>
        Are you sure you wish to <strong>permanently</strong> delete user
        <span class="has-text-primary">{{user ? user.email : ''}}</span>?
      </p>
      <p v-if="errors.user" class="help is-danger pt-2">{{errors.user}}</p>
      <div class="pt-5">
        <button class="button is-primary mr-5" @click.prevent="submit">Yes</button>
        <button class="button is-default" @click="$emit('complete')">No</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';


export default {
  name: 'delete-user-form',
  data () {
    return {
      data: {},
      errors: {}
    };
  },
  props: ['user'],
  methods: {
    async submit() {
      try {
        await api.admin.users.remove(this.user.id);
        this.errors = {};
        this.data = {};
        this.$emit('complete');
      } catch (error) {
        this.handle();
      }
    },
    handle() {
      this.errors = {};
      this.errors.user = 'There was an error deleting this user.';
    }
  }
};
</script>
